import { useId } from 'react'
import { FaInfoCircle } from 'react-icons/fa'
import styles from './ineligibleFundingClientsMetricCard.module.scss'

interface IneligibleFundingClientsMetricCardProps {
    label: string
    value: string
    pct: number
    variant?: 'orange' | 'blue' | 'purple'
    /** Shown in a hover tooltip next to the info icon */
    info?: string
    /** When true, tooltip is anchored from the left so it extends rightward (e.g. left column cards). */
    infoTooltipExtendRight?: boolean
}

export const IneligibleFundingClientsMetricCard = ({
    label,
    value,
    pct,
    variant = 'orange',
    info,
    infoTooltipExtendRight = false,
}: IneligibleFundingClientsMetricCardProps) => {
    const fillPct = Math.min(Math.max(pct, 0), 100)
    const displayPct = fillPct >= 100 ? '100' : fillPct > 99 ? (Math.floor(fillPct * 10) / 10).toFixed(1) : `${Math.round(fillPct)}`
    const tooltipId = useId()

    const variantClass = variant === 'blue' ? styles.variantBlue : variant === 'purple' ? styles.variantPurple : styles.variantOrange

    return (
        <div className={styles.card}>
            <div className={styles.content}>
                <div className={styles.topRow}>
                    <span className={styles.label}>{label}</span>
                    {info ? (
                        <span
                            className={`${styles.infoWrap} ${infoTooltipExtendRight ? styles.infoWrapExtendRight : ''}`}
                        >
                            <button
                                type="button"
                                className={styles.infoBtn}
                                aria-describedby={tooltipId}
                                aria-label={`About ${label}`}
                            >
                                <FaInfoCircle className={styles.infoIcon} aria-hidden />
                            </button>
                            <span id={tooltipId} className={styles.tooltip} role="tooltip">
                                {info}
                            </span>
                        </span>
                    ) : null}
                </div>
                <span className={styles.value}>
                    {value} <span className={styles.percent}>({displayPct}%)</span>
                </span>
            </div>
            <div className={styles.progress} aria-hidden="true">
                <div className={`${styles.progressFill} ${variantClass}`} style={{ width: `${fillPct}%` }} />
            </div>
        </div>
    )
}
